<template>
  <v-container fluid class="ret-cards-wrapper">
    <v-card class="ret-card-new">
      <v-card-title class="pb-4">
        <h3 class="headline">{{ $tc(`${entityPlural}.export`, 2) }}</h3>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" v-if="$can('manager')" @click="exportEntity" color="primary" dark fab small>
              <v-icon>vertical_align_bottom</v-icon>
            </v-btn>
          </template>
          {{ $t(`${entityPlural}.export-to-csv`) }}
        </v-tooltip>
      </v-card-title>
    </v-card>
    <v-card class="ret-card-new">
      <v-card-title>
        <h3 class="headline">{{ $tc(`${entityPlural}.import`, 2) }}</h3>
      </v-card-title>
      <import-csv
        :entity="entity"
        :import-result="postgresResult"
        v-on:validateCSV="sendAndValidateCSV($event)"
        v-on:applyCSV="sendAndApplyCSV($event)"
        v-on:importCancelled="resetResults"
        ref="importCsv">
      </import-csv>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>

<script>
import itemsHelpers from '../helpers/items-helpers.es6'
import moment from 'moment'
import ImportCsv from '../imports/components/import-csv'
import axios from 'axios'

export default {
  mixins: [itemsHelpers],
  data () {
    return {
      model: { name: `${this.$route.params.entity}s`, sort_col: 'name' },
      entity: this.$route.params.entity,
      entityPlural: `${this.$route.params.entity}s`,
      summaryData: undefined,
      postgresResult: undefined
    }
  },
  methods: {
    async exportEntity () {
      const exportData = await axios.get(`/export-csv/${this.entity}`)
      const filename = moment().format('YYYY-MM-DD_hh-mm') + `_${this.entity}Export.csv`
      const link = document.createElement('a')
      document.body.appendChild(link)
      link.setAttribute('href', encodeURI(exportData.data))
      link.setAttribute('download', `${filename}`)
      link.click()
      document.body.removeChild(link)
    },
    async sendAndValidateCSV (e) {
      const formData = new FormData()
      formData.append('file', e)
      formData.append('csvImportName', this.entityPlural)
      formData.append('requiredAction', 'validate')
      const result = await this.$store.dispatch('importCSV', { csvFile: formData })
      this.$refs.importCsv.normalizeData(result.data)
    },
    async sendAndApplyCSV (e) {
      const formData = new FormData()
      formData.append('file', e)
      formData.append('csvImportName', this.entityPlural)
      formData.append('requiredAction', 'apply')
      const result = await this.$store.dispatch('importCSV', { csvFile: formData })
      this.postgresResult = result.data
    },
    resetResults () {
      this.summaryData = undefined
      this.postgresResult = undefined
    }
  },
  components: {
    ImportCsv
  }
}
</script>
